import { render, staticRenderFns } from "./BookChartPonds.vue?vue&type=template&id=426c96dd&"
import script from "./BookChartPonds.vue?vue&type=script&lang=js&"
export * from "./BookChartPonds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports